module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/attractions-food-5a3f36ad1149fe367e4dcdc0d36c8b1b.jpg";